var _circle, _circle2, _g, _circle3, _circle4, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVAda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#1F2028"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 64,
    height: 64,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31.5,
    fill: "#1F2028",
    stroke: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M32 72.212.96 8.983l8.08-3.966L32 51.788 54.96 5.017l8.08 3.966L32 72.212Z",
    clipRule: "evenodd",
    opacity: 0.8
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 28,
    fill: "url(#b)",
    opacity: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24,
    fill: "#1F2028"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.773 31.893a2.155 2.155 0 0 0 2.03 2.27h.128a2.143 2.143 0 0 0 2.15-2.159 2.143 2.143 0 0 0-2.158-2.15c-1.143 0-2.09.896-2.15 2.04Zm-8.038-.554a.697.697 0 1 0-.076 1.39.697.697 0 0 0 .075-1.39Zm7.901-11.955a.704.704 0 0 0 .307-.939.704.704 0 0 0-.938-.307.694.694 0 0 0-.308.93.69.69 0 0 0 .939.316s-.008 0 0 0Zm2.184 3.814c.53-.264.743-.913.479-1.442a1.077 1.077 0 0 0-1.443-.477 1.077 1.077 0 0 0-.477 1.442c.264.529.913.742 1.442.477Zm-7.355 2.62a.893.893 0 0 0 1.229-.256.892.892 0 0 0-.256-1.229.892.892 0 0 0-1.229.256.883.883 0 0 0 .256 1.229Zm1.305 5.137a1.072 1.072 0 0 0-1.134 1.015 1.071 1.071 0 0 0 1.015 1.135 1.077 1.077 0 0 0 .12-2.15Zm-1.186 7.227a.89.89 0 0 0 .803 1.587.89.89 0 0 0-.803-1.587Zm4.182-9.454a1.256 1.256 0 0 0 1.749-.367 1.256 1.256 0 0 0-.367-1.75 1.256 1.256 0 0 0-1.75.367 1.26 1.26 0 0 0 .368 1.75Zm13.268-5.615a1.083 1.083 0 0 0 1.494-.307 1.083 1.083 0 0 0-.308-1.493 1.083 1.083 0 0 0-1.493.307 1.066 1.066 0 0 0 .307 1.493Zm2.202-3.797c.324.213.75.12.964-.205a.693.693 0 0 0-.205-.964.699.699 0 0 0-.964.196.719.719 0 0 0 .205.973Zm-2.039 10.521a2.15 2.15 0 0 0-2.27 2.03 2.15 2.15 0 0 0 2.03 2.27h.12c1.186 0 2.15-.964 2.15-2.158a2.138 2.138 0 0 0-2.03-2.142Zm-9.668-1.263a2.154 2.154 0 0 0 4.079-.973 2.18 2.18 0 0 0-.231-.972 2.15 2.15 0 0 0-2.893-.956 2.163 2.163 0 0 0-.955 2.901Zm16.886-2.756a.89.89 0 0 0 .384-1.195.89.89 0 0 0-1.587.802c.23.436.76.615 1.203.393Zm-5.461.682a1.266 1.266 0 1 0 1.698.564 1.273 1.273 0 0 0-1.698-.563Zm-7.04-7.508a.9.9 0 0 0 .939-.837c.034-.486-.35-.904-.836-.938a.892.892 0 0 0-.939.828.902.902 0 0 0 .836.947Zm-.008 5.572c.7.042 1.297-.495 1.331-1.195a1.256 1.256 0 0 0-1.195-1.331 1.257 1.257 0 0 0-1.33 1.195 1.26 1.26 0 0 0 1.194 1.33ZM25.045 37.5a1.265 1.265 0 1 0-1.136-2.262 1.265 1.265 0 0 0 1.136 2.262Zm7.68-11.085a2.148 2.148 0 0 0 .623 2.978c.998.649 2.33.376 2.978-.623a2.148 2.148 0 0 0-1.8-3.327c-.726 0-1.4.366-1.8.972Zm3.746 9.011a2.15 2.15 0 0 0-2.892-.956 2.15 2.15 0 0 0-.956 2.893 2.15 2.15 0 0 0 2.893.956 2.144 2.144 0 0 0 .964-2.876c0-.008 0-.008-.009-.017Zm3.763-.153a1.256 1.256 0 0 0-1.75.366 1.256 1.256 0 0 0 .368 1.75 1.256 1.256 0 0 0 1.749-.367 1.259 1.259 0 0 0-.367-1.75Zm4.13-3.235a1.072 1.072 0 0 0-1.016-1.134 1.072 1.072 0 0 0-1.134 1.015c-.035.597.418 1.1 1.015 1.135.589.034 1.1-.427 1.135-1.016Zm2.978-.768a.697.697 0 1 0 .657.734.702.702 0 0 0-.657-.733Zm-2.807 6.912a.892.892 0 0 0-1.23.256.892.892 0 0 0 .257 1.229.892.892 0 0 0 1.229-.256.883.883 0 0 0-.256-1.229Zm-19.779 6.502a.699.699 0 0 0-.965.197.698.698 0 0 0 .197.964c.324.213.75.12.964-.197a.685.685 0 0 0-.197-.964Zm14.608-.068a.704.704 0 0 0-.307.939c.17.34.597.477.938.307a.694.694 0 0 0 .308-.93.69.69 0 0 0-.94-.316s.01 0 0 0Zm-8.089-7.031a2.16 2.16 0 0 0-.623-2.987 2.16 2.16 0 0 0-2.987.623 2.152 2.152 0 0 0 1.8 3.337 2.124 2.124 0 0 0 1.81-.973Zm-4.309 3.302a1.083 1.083 0 0 0-1.494.307 1.083 1.083 0 0 0 .307 1.493 1.083 1.083 0 0 0 1.494-.307 1.068 1.068 0 0 0-.307-1.493Zm5.025 4.121a.9.9 0 0 0-.938.837c-.034.486.35.904.836.938a.892.892 0 0 0 .939-.827.902.902 0 0 0-.837-.948ZM32 39.437a1.256 1.256 0 0 0-1.331 1.194c-.043.7.495 1.297 1.194 1.331.7.034 1.297-.495 1.331-1.194A1.261 1.261 0 0 0 32 39.437Zm5.18 1.365a1.078 1.078 0 0 0 .98 1.92c.53-.265.743-.913.479-1.442a1.089 1.089 0 0 0-1.46-.478Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 59.284,
    x2: -9.421,
    y1: 48.315,
    y2: 6.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CFFA2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVAda);
export default __webpack_public_path__ + "static/media/vAda.e72a082cd81bb374019ef77291522f1c.svg";
export { ForwardRef as ReactComponent };